import { useAppStore } from '@/store'
import { Breadcrumb } from '@/store/modules/app/app.interface'
import { RouteLocationNormalized } from 'vue-router'

export function setBreadcrumbList (to: RouteLocationNormalized) {
  const { relationMenuPath, extendBreadcrumb } = to.meta
  const path = relationMenuPath || to.path
  const app = useAppStore()
  const { menuList } = app
  let list: Breadcrumb[] = []
  menuList.forEach(i => {
    if (i.children?.length) {
      i.children.forEach(x => {
        if (x.children?.length) {
          x.children.forEach(y => {
            if (y.url === path) {
              list = [
                {
                  name: i.name,
                  path: i.url
                },
                {
                  name: x.name,
                  path: x.url
                },
                {
                  name: y.name,
                  path: y.url
                }
              ]
            }
          })
        } else {
          if (x.url === path) {
            list = [
              {
                name: i.name,
                path: i.url
              },
              {
                name: x.name,
                path: x.url
              }
            ]
          }
        }
      })
    } else {
      if (i.url === path) {
        list = [
          {
            name: i.name,
            path: i.url
          }
        ]
      }
    }
  })
  if (extendBreadcrumb && Array.isArray(extendBreadcrumb)) {
    list = list.concat(extendBreadcrumb)
  }
  if (!list.length) {
    list = [{
      name: to.meta.title || '',
      path: to.fullPath
    }]
  }
  app.$patch({
    breadcrumbList: list
  })
}
